import { RoseMark } from "./common";
import { NAV_SECTIONS } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Footer = () => (
  <footer className="bg-ink text-ivory">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
      <div className="grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <RoseMark className="w-10 h-10 text-gold" />
            <div>
              <p className="font-serif text-xl font-semibold leading-tight">
                Santa Caterina
              </p>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold">
                d'Alessandria · Galatina
              </p>
            </div>
          </div>
          <p className="mt-6 text-sm text-ivory/60 leading-relaxed max-w-xs">
            Progetto didattico di divulgazione storico-artistica dedicato alla
            Basilica di Santa Caterina d'Alessandria di Galatina (Lecce).
          </p>
        </div>
        <div>
          <h3 className="font-mono text-xs tracking-[0.25em] uppercase text-gold">
            Esplora
          </h3>
          <nav className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3" aria-label="Collegamenti del sito">
            {[...NAV_SECTIONS, { id: "fonti", label: "Fonti" }].map(({ id, label }) => (
              <button
                key={id}
                onClick={() => scrollToId(id)}
                data-testid={`footer-link-${id}`}
                className="text-left text-sm text-ivory/65 hover:text-goldlight transition-colors duration-300"
              >
                {label}
              </button>
            ))}
          </nav>
        </div>
        <div>
          <h3 className="font-mono text-xs tracking-[0.25em] uppercase text-gold">
            Crediti
          </h3>
          <p className="mt-5 text-sm text-ivory/60 leading-relaxed">
            Le fotografie sono immagini d'archivio (Unsplash, Pexels) utilizzate
            a scopo illustrativo e didattico, in attesa di documentazione
            fotografica diretta del monumento.
          </p>
          <p className="mt-3 text-sm text-ivory/60 leading-relaxed">
            I contenuti storici sono elaborati da fonti istituzionali citate
            nella sezione Fonti.
          </p>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-ivory/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-ivory/45 font-mono tracking-wider">
          Basilica di Santa Caterina d'Alessandria · Galatina (LE) · Puglia
        </p>
        <p className="text-xs text-ivory/45 font-mono tracking-wider">
          Realizzato a scopo didattico
        </p>
      </div>
    </div>
  </footer>
);
